import { connect } from 'react-redux';

import { fetchPasswordResetWithRedirect, updatePassword } from './actions';
import PasswordChangePage from './PasswordChangePage';
import { State } from './reducer';

import type { AnyAction } from 'redux';
import type { ThunkDispatch } from '~/Store';

interface Props {
	title: string;
	changeButtonLabel: string;
	isFetching: boolean;
}

function mapStateToProps(state: { passwordChange: State }): Props {
	return {
		title: 'Setup new password',
		changeButtonLabel: 'Change password',
		isFetching: state.passwordChange.request !== null,
	};
}

function mapDispatchToProps(
	dispatch: ThunkDispatch<AnyAction>,
	props: { token: string | null; userId: string | null; redirectUrl: string }
) {
	return {
		onFetch: () => {
			const { token, userId, redirectUrl } = props;
			dispatch(fetchPasswordResetWithRedirect(token, userId, redirectUrl));
		},
		onAccept: (password: string, passwordCheck: string) => dispatch(updatePassword(password, passwordCheck)),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(PasswordChangePage);
